import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
// import { makeStyles } from '@material-ui/core/styles'
// import ZoomInIcon from '@material-ui/icons/ZoomIn'
import BottomBarButton from '../BottomBar/BottomBarButton'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import {
  currentPageIdxSelector,
  pageCountSelector,
  setPageIdx
} from '../../modules/reducerPDFViewer'

// const useStyles = makeStyles((theme) => ({
//   root: {}
// }))

const PDFNextButton = (props) => {
  // const classes = useStyles()
  const pageCount = useSelector(pageCountSelector)
  const pageIdx = useSelector(currentPageIdxSelector)
  const dispatch = useDispatch()

  const handleClick = useCallback(() => {
    dispatch(setPageIdx(pageIdx + 1))
  }, [dispatch, pageIdx])

  return (
    <BottomBarButton
      {...props}
      tooltip="Siguiente"
      tooltipEnabled={true}
      onClick={handleClick}
      disabled={pageIdx === pageCount - 1}
    >
      <ArrowDownwardIcon fontSize="inherit" />
    </BottomBarButton>
  )
}
export default PDFNextButton
